module.exports = __webpack_public_path__ + "fontawesome-webfont.912ec66d7572ff821749.svg";


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = 7